exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jobtype{\n    position: relative;\n    display:inline-block;\n    width:100%;\n}\n.radio {\n    width:25px;\n}\n.group{\n    display:inline-block;\n    margin-right:50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3631b5e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/status.vue
// module id = 868
// module chunks = 0